export default "__VITE_ASSET__BjV27mfR__"